import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  public token: any | null;
  public url: any;
  public mtds: Methods = new Methods();
  public headers: HttpHeaders;
  public headers2: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
     this.token = JSON.parse(localStorage.getItem('token'));

    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    this.headers2 = new HttpHeaders({
      'Content-Type': 'text/plain',
      'X-Requested-With': 'XMLHttpRequest',
    });

  }

  listInventory(token: any, page: any, perPage: any): Observable<any> {
    const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const url = `${this.url}/inventory/listall?page=${page}&items_per_page=${perPage}`;

    return this._http.post<any>(url, params, { headers });
  }

  search(token: any, task: any, page: any, perPage: any): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    const params = { json, authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const url = `${this.url}/inventory/search?page=${page}&perpage=${perPage}`;

    return this._http.post<any>(url, params, { headers });
  }

  detailbymix(token: any, task: any): Observable<any> {
   let json = JSON.stringify(task);
  let params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/detailbymix?page=${page}`, params, { headers });
  }

  especificedit(token: any, task: any, id: any): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    const params = { json, authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/especificedit/${id}?page=${page}`, params, { headers });
  }

  markasscrap(token: any, id: any): Observable<any> {
    let params = `authorization=${token}`;
    //const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/markasscrap/${id}?page=${page}`, params, { headers });
  }

  markasunscrap(token: any, id: any): Observable<any> {
    let params = `authorization=${token}`;
    
    //const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/markasunscrap/${id}?page=${page}`, params, { headers });
  }

  bulkchangescheck(token: any, task: any): Observable<any> {
  
    return this.petition(`${this.url}/inventory/bulkchangescheck`, task);
  }

  bulkmarkasscrap(token: any, task: any): Observable<any> {
   /* let json = JSON.stringify(task);
     json = encodeURIComponent(json);
    const params = { json, authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/bulkmarkasscrap?page=${page}`, params, { headers });
*/
    return this.petition(`${this.url}/inventory/bulkmarkasscrap`, task);
  }


  

  bulkmarkasunscrap(token: any, task: any): Observable<any> {
    /*let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    const params = { json, authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/bulkmarkasunscrap?page=${page}`, params, { headers });
*/
    return this.petition(`${this.url}/inventory/bulkmarkasunscrap`, task);
  }

  viewInventoryByInventoryID(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/detailbyinventoryid/${id}?page=${page}`, params, { headers });
  }

  viewInventoryByRange(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/detailbyrange/${id}?page=${page}`, params, { headers });
  }

  updateverbiage(token: any, task: any): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    const params = { json, authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/updateverbiage?page=${page}`, params, { headers });
  }

  updater2(token: any, task: any): Observable<any> {
    let json = JSON.stringify(task);
  let params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/updater2?page=${page}`, params, { headers });
  }

  getMultipleItems(token: any, task: any): Observable<any> {
   
   

    let json = JSON.stringify(task);
  let params = `json=${json}&authorization=${token}`;

   
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/getmultipleitems?page=${page}`, params, { headers });
  }

  saveMultipleItems(token: any, task: any): Observable<any> {
    let json = JSON.stringify(task);
    
    let params = `json=${json}&authorization=${token}`;
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/savemultipleitems?page=${page}`, params, { headers });
  }

  viewInventory(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/inventory/detail/${id}?page=${page}`, params, { headers });
  }


    private petition(url: any, json: any = null, type: any | null = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = `authorization=${this.token}`;
    if (json != null) {
      params += `&json=${encodeURIComponent(JSON.stringify(json))}`;
    }
    if (type != null) {
      params += `&type=${type}`;
    }
    

    return this._http.post(url, params, { headers: this.headers })
      .pipe(
        map((res: any) => res),
        catchError((error: any) => {
          if (error.code === 404) {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
          throw error;
        })
      );
  }

}
